import portfolio1 from '../assets/portfolio1.png'
import portfolio2 from '../assets/portfolio2.png'
import portfolio3 from '../assets/portfolio3.png'
import portfolio4 from '../assets/portfolio4.png'
import portfolio5 from '../assets/portfolio5.png'
import portfolio6 from '../assets/portfolio6.png'
import portfolio7 from '../assets/portfolio7.png'
import portfolio8 from '../assets/portfolio8.png'
import portfolio9 from '../assets/portfolio9.png'
import portfolio10 from '../assets/portfolio10.png'
import portfolio11 from '../assets/portfolio11.png'
import portfolio12 from '../assets/portfolio12.png'
import portfolio13 from '../assets/portfolio13.png'

export const portfolioImages = [
    portfolio1,
    portfolio2,
    portfolio3,
    portfolio4,
    portfolio5,
    portfolio6,
    portfolio7,
    portfolio8,
    portfolio9,
    portfolio10,
    portfolio11,
    portfolio12,
    portfolio13,
    // portfolio14,
];